package link.erpango.quip.data.firebase

import link.erpango.quip.core.auth.IFirebaseUserWrapper

class JsFirebaseClient : IFirebaseClient {
    override suspend fun fetchRemoteConfig(): Map<String, String> {
        println("JsFirebaseClient: fetchRemoteConfig called")
        return emptyMap()
    }

    override fun logAnalyticsEvent(name: String, value: String?) {
        println("JsFirebaseClient: logAnalyticsEvent: $name, value: $value")
    }

    override fun getDeviceFCMToken(dataSourceListener: (String?) -> Unit) {
        println("JsFirebaseClient: getDeviceFCMToken called")
        dataSourceListener(null)
    }

    override fun setOnConfigUpdateListener() {
        println("JsFirebaseClient: setOnConfigUpdateListener called")
    }

    override fun signIn(email: String, pass: String) {
        println("JsFirebaseClient: signIn with $email")
    }

    override fun signUp(email: String, pass: String) {
        println("JsFirebaseClient: signUp with $email")
    }

    override fun signOut() {
        println("JsFirebaseClient: signOut")
    }

    override fun resetPassword(email: String) {
        println("JsFirebaseClient: resetPassword for $email")
    }

    override fun getCurrentUser(): IFirebaseUserWrapper? {
        println("JsFirebaseClient: getCurrentUser called")
        return null
    }
}
